<mat-card style="margin-top: 30px">
  <mat-card-header>
    <h2 mat-card-title><mat-icon>analytics</mat-icon>Migration details</h2>
    <!-- <div>
      <button mat-button>
        <mat-icon>chevron_left</mat-icon>Back to migrations
      </button>
    </div> -->
  </mat-card-header>
  <mat-card-content class="main-mat-card-content">
    <app-progress-tracker
      [progress]="migration?.progressPercentage"
      [status]="migration?.status"
      [label]="migration?.company_name"
      [extraLabel]="migration?.status"
      [tooltipText]="getTooltipText()"
      [showPercentage]="true"
      [animateProgress]="true"
    ></app-progress-tracker>
    @if (
      firstLoadingFinished && migration?.status == MigrationStatus.exception
    ) {
      <div class="mat-card-extra-info">
        <mat-card appearance="outlined">
          <mat-card-header [ngClass]="migration?.status">
            <mat-card-title class="gray">Exception</mat-card-title>
          </mat-card-header>
          <mat-card-content class="error-card-content">
            <span class="error">{{ migration?.exception }}</span>
          </mat-card-content>
        </mat-card>
      </div>
    }
    @if (firstLoadingFinished && migration?.status == MigrationStatus.reject) {
      <div class="mat-card-extra-info">
        <mat-card appearance="outlined">
          <mat-card-header [ngClass]="migration?.status">
            <mat-card-title class="warning">Migration rejected</mat-card-title>
            <mat-card-subtitle
              >by
              <span class="rejectByUser">{{
                migration?.created_by
              }}</span></mat-card-subtitle
            >
          </mat-card-header>
          <mat-card-content class="error-card-content">
            <span>Reason:</span><br /><br />
            <span class="gray">{{ migration?.description }}</span>
          </mat-card-content>
        </mat-card>
      </div>
    }

    @if (firstLoadingFinished) {
      @if (entityTypes.length > 0) {
        <div class="metrics-summary-container">
          <div class="metric-item total">
            <mat-icon color="primary">storage</mat-icon>
            <span class="metric-label">Total records:</span>
            <span class="metric-value">{{ overallMetrics.totalRecords }}</span>
          </div>

          <div class="metric-item succeeded">
            <mat-icon color="success">check_circle</mat-icon>
            <span class="metric-label">Succeeded:</span>
            <span class="metric-value">{{ overallMetrics.succeeded }}</span>
          </div>

          <div class="metric-item failed">
            <mat-icon color="error">error</mat-icon>
            <span class="metric-label">Failed</span>
            <span class="metric-value">{{ overallMetrics.failed }}</span>
          </div>
        </div>
      }
      <div class="statistics-summary-container">
        <!-- no_of_protocols -->
        <div class="statistic-item">
          <mat-icon color="primary">play_circle</mat-icon>
          <span class="statistic-label">Studies:</span>
          <span class="statistic-value" class="primary">{{
            migration?.statistics_obj?.no_of_protocols
          }}</span>
        </div>
        <div class="statistic-item">
          <mat-icon color="success-light">play_circle</mat-icon>
          <span class="statistic-label">Started:</span>
          <span class="statistic-value" class="success">{{
            migration?.statistics_started_local
          }}</span>
        </div>
        <div class="statistic-item">
          <mat-icon color="success">task_alt</mat-icon>
          <span class="statistic-label">Ended:</span>
          <span class="statistic-value" class="success">{{
            migration?.statistics_ended_local
          }}</span>
        </div>
        <div class="statistic-item">
          <mat-icon color="primary">schedule</mat-icon>
          <span class="statistic-label">Duration:</span>
          <span class="statistic-value" class="primary">{{
            migration?.durationText || "0s"
          }}</span>
        </div>

        <div class="statistic-item">
          <a
            mat-stroked-button
            color="primary"
            [routerLink]="['/statistics']"
            [queryParams]="{ migrationId: migrationId }"
          >
            <mat-icon>bar_chart</mat-icon>
            Open statistics page
          </a>
        </div>
      </div>

      @if (entityTypes.length > 0) {
        <div class="details-tabs-container">
          <mat-tab-group>
            <mat-tab label="Migration by entity type">
              <!-- <mat-expansion-panel [expanded]="true" id="migrated-entity-tab"> -->
              <mat-card id="migrated-entity-tab">
                <!-- <mat-expansion-panel-header>
                <mat-panel-title>
                  Migration metrics by entity type
                </mat-panel-title>
              </mat-expansion-panel-header> -->

                <div class="migration-metrics-container">
                  <mat-grid-list
                    [cols]="cols"
                    [rowHeight]="rowHeight"
                    gutterSize="12px"
                  >
                    <mat-grid-tile *ngFor="let entityType of entityTypes">
                      <mat-card class="metric-card compact">
                        <mat-card-header>
                          <mat-card-title class="metric-header-title-container">
                            <span class="metric-header-title">{{
                              utilsService.capitalizeFirstLetter(entityType)
                            }}</span>
                            <div class="metric-total-container">
                              <mat-icon class="chip-icon">{{
                                groupedMetrics[entityType][0].icon
                              }}</mat-icon>
                              <span class="metric-total-text"
                                >Total: {{ getTotalCount(entityType) }}</span
                              >
                            </div>
                          </mat-card-title>
                        </mat-card-header>

                        <mat-card-content>
                          <table
                            mat-table
                            [dataSource]="groupedMetrics[entityType]"
                            class="metrics-table compact"
                          >
                            <!-- Status Column -->
                            <ng-container matColumnDef="status">
                              <th mat-header-cell *matHeaderCellDef>Status</th>
                              <td
                                mat-cell
                                *matCellDef="let metric"
                                [ngClass]="metric.displayData.statusColor"
                              >
                                {{ metric.migration_status }}
                              </td>
                            </ng-container>

                            <!-- Count Column -->>

                            <!-- Count Column -->
                            <ng-container matColumnDef="count">
                              <th mat-header-cell *matHeaderCellDef>Count</th>
                              <td mat-cell *matCellDef="let metric">
                                {{ metric.count }}
                              </td>
                            </ng-container>

                            <tr
                              mat-header-row
                              *matHeaderRowDef="displayedColumns"
                            ></tr>
                            <tr
                              mat-row
                              *matRowDef="let row; columns: displayedColumns"
                            ></tr>
                          </table>
                        </mat-card-content>
                      </mat-card>
                    </mat-grid-tile>
                  </mat-grid-list>
                </div>
                <!-- </mat-expansion-panel> -->
              </mat-card>
            </mat-tab>
          </mat-tab-group>
        </div>
      }
    }
  </mat-card-content>
  <mat-card-footer> *migration metrics </mat-card-footer>
</mat-card>
